import { render, staticRenderFns } from "./StartReservation.vue?vue&type=template&id=006627c9&scoped=true&"
import script from "./StartReservation.vue?vue&type=script&lang=js&"
export * from "./StartReservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006627c9",
  null
  
)

export default component.exports